import { BASE_URL } from 'config';
import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
  Typography,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
} from "@mui/material";
import { UploadFile } from "@mui/icons-material";
import { PrimaryColor } from "assets/theme/base/themeColors";
import { validateEmail, validateRequired, validatePasswordMatch } from "validations";
import axios from "axios";
import Swal from "sweetalert2";
import { useMaterialUIController } from "context";
import { useTheme } from "@mui/material/styles";
const AddPaymentConfigsForm = ({ onClose, onSuccess, initialData }) => {
  const [controller] = useMaterialUIController();
  const darkMode = controller.darkMode;
  const theme = useTheme();
  const [paymentMethods, setPaymentMethods] = useState([]);
  useEffect(() => {
    const fetchPaymentMethods = async () => {
      const token = localStorage.getItem("user-token");
      const response = await fetch(
        BASE_URL + "/administrator/payment-methods",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      setPaymentMethods(data.data);
    };
    fetchPaymentMethods();
  }, []);
  const [formData, setFormData] = useState({
    payment_method_id: initialData?.payment_method_id || null,
    key: initialData?.key || "",
    value: initialData?.value || "",
    id: initialData?.id || null, // Add ID field
  });

  // Add useEffect to handle initial data
  useEffect(() => {
    if (initialData) {
      setFormData({
        payment_method_id: initialData.payment_method_id,
        key: initialData.key,
        value: initialData.value,
        id: initialData.id,
      });
    }
  }, [initialData]);
  const [errors, setErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    if (formSubmitted) validateForm();
  }, [formData]);

  const validateForm = () => {
    const newErrors = {};

    if (!validateRequired(formData.key)) newErrors.key = "يجب إدخال  مفتاح اعدادات طريقة الدفع";
    if (!formData.payment_method_id) newErrors.payment_method_id = "يجب اختيار  طريقة الدفع";
    if (!validateRequired(formData.value)) newErrors.value = "يجب إدخال  قيمة اعدادات طريقة الدفع";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && ["image/png", "image/jpeg", "image/gif"].includes(file.type)) {
      setFormData((prev) => ({ ...prev, image: file }));
      setErrors((prev) => ({ ...prev, image: "" }));
    } else {
      setErrors((prev) => ({ ...prev, image: "يجب أن تكون الصورة بصيغة PNG, jpeg, أو GIF" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    if (!validateForm()) return;

    try {
      const formPayload = new FormData();
      // Append all form data including files
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined && key !== "id") {
          // Handle avatar differently for existing vs new
          formPayload.append(key, value);
        }
      });

      // Show loading indicator
      Swal.fire({
        title: "جاري الحفظ...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
      console.log("Sending payload:", formPayload); // طباعة البيانات المرسلة
      const token = localStorage.getItem("user-token");
      const endpoint = formData.id
        ? `${BASE_URL}/administrator/payment-methods-configs/update/${formData.id}`
        : BASE_URL + "/administrator/payment-methods-configs/store";

      const response = await axios.post(endpoint, formPayload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      // طباعة تفاصيل الرد
      console.log("Full Response:", response);
      console.log("Response Data:", response.data);
      console.log("Status Code:", response.status);
      // Close loading indicator
      Swal.close();

      if (response.data.status) {
        await Swal.fire({
          icon: "success",
          title: "تم الحفظ!",
          text: "تم حفظ البيانات بنجاح",
          confirmButtonText: "موافق",
          didOpen: () => {
            const container = document.querySelector(".swal2-container");
            container.style.zIndex = "99999";
          },
        });
        onSuccess();
        onClose();
      } else {
        throw new Error(response.data.message || "حدث خطأ غير متوقع");
      }
    } catch (error) {
      Swal.close();
      console.error("Error Details:", error);
      console.log("Error Response:", error.response?.data);
      const errorMessage = error.response?.data?.message || error.message || "حدث خطأ أثناء  الحفظ";

      Swal.fire({
        icon: "error",
        title: "فشل الحفظ!",
        text: errorMessage,
        confirmButtonText: "موافق",
        didOpen: () => {
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
    } finally {
      setFormSubmitted(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      payment_method_id: null,
      key: "",
      value: "",
    });
    setErrors({});
    onClose();
  };
  console.log("formData", formData);
  return (
    <Box
      sx={{
        p: 3,
        width: 600,
        bgcolor: darkMode ? theme.palette.background.default : "background.paper",
        borderRadius: 2,
        boxShadow: 3,
        color: darkMode ? "white !important" : "inherit",
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">
          {formData.id ? "تعديل بيانات اعدا الدفع" : "إضافة اعدادات طريقة الدفع جديدة"}
        </Typography>
      </Box>
      <Typography variant="subtitle1" gutterBottom fontWeight="bold">
        اعدادات طريقة الدفع
      </Typography>
      {/* Main Form */}
      <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="payment_method"> طريقة الدفع </InputLabel>
          <Select
            labelId="payment_method"
            name="payment_method_id"
            value={formData.payment_method_id}
            onChange={handleChange}
            sx={{ height: 43 }}
          >
            {paymentMethods.map((method) => (
              <MenuItem key={method.id} value={method.id}>
                {method.name}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{errors.payment_method_id}</FormHelperText>
        </FormControl>
      </Box>
      <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
        <FormControl fullWidth error={!!errors.key} sx={{ mb: 2 }}>
          <TextField
            label="ادخل المفتاح (key)*"
            name="key"
            value={formData.key}
            onChange={handleChange}
            error={!!errors.key}
            helperText={errors.key}
          />
        </FormControl>
      </Box>
      <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
        <FormControl fullWidth error={!!errors.value} sx={{ mb: 2 }}>
          <TextField
            label="ادخل القيمة (value)*"
            name="value"
            value={formData.value}
            onChange={handleChange}
            error={!!errors.value}
            helperText={errors.value}
          />
        </FormControl>
      </Box>

      {/* Preview uploaded image if exists */}
      {/* Actions Section */}
      <Box mt={4} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" color="textSecondary">
          * الحقول المطلوبة
        </Typography>

        <Box display="flex" gap={2}>
          <Button variant="contained" color="error" onClick={handleCancel} sx={{ px: 4 }}>
            إلغاء
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            // disabled={Object.keys(errors).length > 0}
            sx={{ px: 4, color: "white !important" }}
            onClick={handleSubmit}
          >
            حفظ
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddPaymentConfigsForm;
